// ============================================================
// types/grado.types.ts
// ============================================================

export type NivelEducativo = 'INICIAL' | 'PRIMARIA' | 'SECUNDARIA';

// ── Payload exacto → POST /grados  y  PUT /grados/{id} ───────
export interface GradoPayload {
  nombre: string;
  nivel:  NivelEducativo;
  activo: boolean;
}

// ── Estado interno del formulario ─────────────────────────────
export interface GradoFormState {
  nombre: string;
  nivel:  NivelEducativo;
  activo: boolean;
}

export const GRADO_FORM_INITIAL: GradoFormState = {
  nombre: '',
  nivel:  'PRIMARIA',
  activo: true,
};

// ── Etiquetas y colores por nivel ─────────────────────────────
export const NIVEL_LABEL: Record<NivelEducativo, string> = {
  INICIAL:    'Inicial',
  PRIMARIA:   'Primaria',
  SECUNDARIA: 'Secundaria',
};

export const NIVEL_COLOR: Record<NivelEducativo, string> = {
  INICIAL:    'bg-amber-100 text-amber-700',
  PRIMARIA:   'bg-blue-100 text-blue-700',
  SECUNDARIA: 'bg-purple-100 text-purple-700',
};
